import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import storeConfig from './redux/store';
import { Provider } from 'react-redux';
import ErrorBoundary from './components/shared-components/ErrorBoundary';
import Loader from './components/layout-components/Loader';
import { HeadProvider } from 'react-head';
const store = storeConfig();
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Provider store={store}>
      <ErrorBoundary>
        <Suspense fallback={<Loader isLoading={true} />}>
          <HeadProvider>
            <App />
          </HeadProvider>
        </Suspense>
      </ErrorBoundary>
    </Provider>
  </StrictMode>
);
